import { AnalyticsEventTopic } from '~/modules/analytics/analyticsHelper';
import { GtmAnalyticsEvent, GtmEventType } from './gtmEventType';

interface GtmNavLinkClickEvent extends GtmAnalyticsEvent {
    navHeading?: string;
    navSubheading?: string;
    navType: string;
    destinationType: string;
    clickUrl: string;
    ctaClick: boolean;
    clickText: string;
    elementType: string;
    itemTitle: string;
}

export class GtmNavLinkClickType extends GtmEventType {
    // @ts-expect-error * Automated Type Error Fix
    canHandle(event): boolean {
        return event.topic === AnalyticsEventTopic.ANALYTICS_CLICK && event.elementType === 'navLink';
    }

    // @ts-expect-error * Automated Type Error Fix
    getBody(event): GtmNavLinkClickEvent {
        return {
            event: event.gtm.type,
            timestamp: event.timestamp,
            elementType: 'link',
            ...event.gtm.fields,
        };
    }
}
